import { Typography } from '@mui/material';
import { DateFormats, TimeFormats } from '@uplift/constants';
import { CalendarDateService, DateObject } from '@uplift/services';
import React from 'react';

export type DateTimeCellProps = {
  value?: DateObject | string;
  timezone?: string;
  showTime?: boolean;
};

export const DateTimeCell: React.VFC<DateTimeCellProps> = ({ value, timezone, showTime = true }) => {
  const date = React.useMemo(() => {
    if (typeof value === 'string') {
      return CalendarDateService.date(value).tz(timezone);
    } else if (CalendarDateService.isDateObject(value)) {
      return value;
    }
    return null;
  }, [ value, timezone ]);

  if (date) {
    return (
      <div>
        <Typography>{date.format(DateFormats['MM/DD/YYYY'])}</Typography>
        {showTime && <Typography variant="body2">{date.format(TimeFormats['h:mm A'])}</Typography>}
      </div>
    );
  }

  return null;
};
